module.exports = __webpack_public_path__ + "img/no-data.cb61ac4f.svg";